import {
  EMPTY_FIELD_MESSAGE,
  validateEditorEn,
  validateSpace,
  validateTextEn,
} from '@Utils/validation';
import { z } from 'zod';

enum OTHER_EXPLANATION_MESSAGE {
  TOPIC = 'กรุณาระบุหัวข้อคำบรรยายอื่น ๆ',
  TOPIC_EN = 'กรุณาระบุหัวข้อคำบรรยายอื่น ๆ เป็นภาษาอังกฤษ',
  DESCRIPTION = 'กรุณาระบุรายละเอียดคำบรรยายอื่น ๆ',
  DESCRIPTION_EN = 'กรุณาระบุรายละเอียดคำบรรยายอื่น ๆ เป็นภาษาอังกฤษ',
}

export const OtherExplanationSchema = z.object({
  titleTh: z
    .string({ message: OTHER_EXPLANATION_MESSAGE.TOPIC })
    .nonempty({ message: OTHER_EXPLANATION_MESSAGE.TOPIC })
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
  titleEn: z
    .string({ message: OTHER_EXPLANATION_MESSAGE.TOPIC })
    .nonempty({ message: OTHER_EXPLANATION_MESSAGE.TOPIC })
    .regex(validateTextEn, OTHER_EXPLANATION_MESSAGE.TOPIC_EN)
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
  descriptionTh: z
    .string({ message: OTHER_EXPLANATION_MESSAGE.DESCRIPTION })
    .nonempty({ message: OTHER_EXPLANATION_MESSAGE.TOPIC })
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
  descriptionEn: z
    .string({ message: OTHER_EXPLANATION_MESSAGE.DESCRIPTION })
    .regex(validateEditorEn, OTHER_EXPLANATION_MESSAGE.DESCRIPTION_EN)
    .nonempty({ message: OTHER_EXPLANATION_MESSAGE.TOPIC })
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
});
